import React, { useState } from "react";
import { BLOG_POSTS } from "@/data/site";
import { ArrowRight } from "@phosphor-icons/react";

const CATS = ["All", "Solar", "CCTV", "EV", "Battery", "AI"];

export default function Blog() {
  const [cat, setCat] = useState("All");
  const filtered = cat === "All" ? BLOG_POSTS : BLOG_POSTS.filter((b) => b.category === cat);

  return (
    <div data-testid="blog-page">
      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="label-eyebrow">Blog</div>
          <h1 className="mt-4 font-heading font-black text-5xl md:text-7xl tracking-tighter text-slate-950 max-w-4xl">
            Insights for a <span className="italic font-light">smarter Tamil Nadu.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg text-slate-600">Guides, price breakdowns, and field notes from our engineers.</p>
        </div>
      </section>

      <section className="bg-slate-50 py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-12">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c.toLowerCase()}`}
                className={`px-4 py-2 text-xs font-semibold uppercase tracking-wider transition-colors ${cat === c ? "bg-slate-950 text-white" : "bg-white border border-slate-300 text-slate-700 hover:border-slate-900"}`}>
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p) => (
              <article key={p.id} className="card-flat overflow-hidden group cursor-pointer" data-testid={`blog-post-${p.id}`}>
                <div className="relative h-52 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute top-4 left-4 bg-white text-slate-950 text-[10px] uppercase tracking-wider font-bold px-2.5 py-1">{p.category}</div>
                </div>
                <div className="p-6">
                  <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">{p.date} • {p.read} read</div>
                  <h3 className="mt-3 font-heading font-bold text-xl text-slate-950 leading-tight">{p.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed line-clamp-3">{p.excerpt}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-950">
                    Read article <ArrowRight size={14} weight="bold" className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
